import type { Todo } from 'owa-todo-types';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import type { OwaDate } from 'owa-datetime';
import { createDatapointConfig } from './createDatapointConfig';
import type { TodoActionTelemetryData } from '../schema/telemetry/TodoActionTelemetryData';
import type { ActionType } from '../schema/telemetry/ActionType';

export const markTodoComplete = action(
    'markTodoComplete',
    (todoId: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('markComplete', telemetryData), {
            todoId,
        })
);

export const markTodoImportant = action(
    'markTodoImportant',
    (todoId: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('markImportant', telemetryData), {
            todoId,
        })
);

export const removeTodoImportance = action(
    'removeTodoImportance',
    (todoId: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('removeImportance', telemetryData), {
            todoId,
        })
);

export const addTodoToMyDay = action(
    'addTodoToMyDay',
    (todoId: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('addToMyDay', telemetryData), {
            todoId,
        })
);

export const removeTodoFromMyDay = action(
    'removeTodoFromMyDay',
    (todoId: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('removeFromMyDay', telemetryData), {
            todoId,
        })
);

export const markTodoIncomplete = action(
    'markTodoIncomplete',
    (todoId: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('markIncomplete', telemetryData), {
            todoId,
        })
);

export const updateTodoSubject = action(
    'updateTodoSubject',
    (todoId: string, subject: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('updateSubject', telemetryData), {
            todoId,
            subject,
        })
);

export const updateTodo = action(
    'updateTodo',
    (
        todoId: string,
        todoUpdates: Partial<Todo>,
        telemetryData: TodoActionTelemetryData & { actionType: ActionType }
    ) =>
        addDatapointConfig(createDatapointConfig(telemetryData.actionType, telemetryData), {
            todoId,
            todoUpdates,
        })
);

export const todoUpdated = action('todoUpdated', (isSuccessful: boolean) => ({
    isSuccessful,
}));

export const deleteTodo = action(
    'deleteTodo',
    (todoId: string, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('delete', telemetryData), {
            todoId,
        })
);

export const updateTodoReminder = action(
    'updateTodoReminder',
    (todoId: string, reminderDateTime: OwaDate | null, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('updateReminder', telemetryData), {
            todoId,
            reminderDateTime,
        })
);

export const updateTodoDueDate = action(
    'updateTodoDueDate',
    (todoId: string, dueDate: OwaDate | null, telemetryData: TodoActionTelemetryData) =>
        addDatapointConfig(createDatapointConfig('updateDueDate', telemetryData), {
            todoId,
            dueDate,
        })
);
